export default function WinzApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getSignalRConnection() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/SignalR/negotiate`));
        });
    }

    return {
        getSignalRConnection
    }

}